import {
  iconButtonClasses,
  inputAdornmentClasses,
  touchRippleClasses,
  typographyClasses,
} from "@mui/material";
import {
  MuiTelInput,
  MuiTelInputCountry,
  MuiTelInputInfo,
} from "mui-tel-input";
import { forwardRef } from "react";

type IPhoneFieldProps = {
  inputRef?: React.Ref<HTMLInputElement>;
  value?: string | MuiTelInputInfo | null;
  name?: string;
  error?: boolean;
  helperText?: string;
  label?: string;
  placeholder?: string;
  onChange?: (value: string, info: MuiTelInputInfo) => void;
  defaultCountry?: MuiTelInputCountry;
  disabled?: boolean;
  forceCallingCode?: true;
  preferredCountries?: MuiTelInputCountry[];
};

export const PhoneField = forwardRef<HTMLInputElement, IPhoneFieldProps>(
  (
    {
      inputRef,
      forceCallingCode = true,
      defaultCountry = "BY",
      preferredCountries = ["BY", "RU", "KZ"],
      ...textFieldProps
    },
    ref,
  ) => {
    return (
      <MuiTelInput
        {...textFieldProps}
        onChange={(value, info) => {
          if (textFieldProps.onChange) {
            textFieldProps.onChange(value, info);
          }
        }}
        value={
          typeof textFieldProps.value === "string"
            ? textFieldProps.value
            : textFieldProps.value?.numberValue || ""
        }
        defaultCountry={defaultCountry}
        inputRef={inputRef}
        ref={ref}
        forceCallingCode={forceCallingCode}
        focusOnSelectCountry
        preferredCountries={preferredCountries}
        slotProps={{
          htmlInput: {
            maxLength: 15,
          },
        }}
        FlagIconButtonProps={{
          sx: {
            [`&.${iconButtonClasses.root}`]: {
              p: 0,
              mr: 1,
              [`& .${touchRippleClasses.root}`]: {
                display: "none",
              },
            },
          },
        }}
        sx={{
          [`& .${inputAdornmentClasses.positionStart}`]: {
            [`& .${typographyClasses.root}`]: {
              fontSize: "0.875rem",
              pr: 1.5,
            },
          },
        }}
      />
    );
  },
);

PhoneField.displayName = "PhoneField";
